import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "./common";
import { Workload } from "../../schema/types/workload/entity";
import { Deployment } from "../../schema/types/workload/deployment";
import { WorkloadCreate } from "../../schema/types/workload/create";

export const workloadApi = createApi({
  reducerPath: "workloadApi",
  baseQuery: customBaseQuery,
  tagTypes: ["Workload", "Deployments"],
  endpoints: (builder) => ({
    getWorkload: builder.query<Workload, string>({
      queryFn: async (link) => {
        try {
          const { request } = await import("../../services/cpln");
          const { data } = await request<Workload>({
            url: link,
          });
          return { data };
        } catch (error: any) {
          return {
            error: {
              status: error.response?.status || 500,
              data: error.response?.data || error.message,
            },
          };
        }
      },
      providesTags: (result, error, link) => {
        return [{ type: "Workload", id: link }];
      },
    }),
    createWorkload: builder.mutation<void, { body: WorkloadCreate; org: string; gvc: string }>({
      queryFn: async (args) => {
        try {
          const { request } = await import("../../services/cpln");
          await request({
            method: "post",
            url: `/org/${args.org}/gvc/${args.gvc}/workload`,
            body: args.body,
          });
          return { data: undefined };
        } catch (error: any) {
          return {
            error: {
              status: error.response?.status || 500,
              data: error.response?.data || error.message,
            },
          };
        }
      },
    }),
    updateWorkload: builder.mutation<Workload, { link: string; body: any }>({
      queryFn: async (args) => {
        try {
          const { request } = await import("../../services/cpln");
          const { data } = await request({
            method: "patch",
            url: args.link,
            body: args.body,
          });
          return { data: data };
        } catch (error: any) {
          return {
            error: {
              status: error.response?.status || 500,
              data: error.response?.data || error.message,
            },
          };
        }
      },
      invalidatesTags: (result, error, args) => [{ type: "Workload", id: args.link }],
    }),
    getDeployments: builder.query<Deployment[], string>({
      queryFn: async (link) => {
        try {
          const { request } = await import("../../services/cpln");
          const { data } = await request({
            url: link + `/deployment`,
          });
          return { data };
        } catch (error: any) {
          return {
            error: {
              status: error.response?.status || 500,
              data: error.response?.data || error.message,
            },
          };
        }
      },
      providesTags: (result, error, link) => {
        return [{ type: "Deployments", id: link }];
      },
    }),
  }),
});

export const {
  useCreateWorkloadMutation,
  useUpdateWorkloadMutation,
  useGetWorkloadQuery,
  useGetDeploymentsQuery,
} = workloadApi;
